//actionType
import {
  GET_MASTER_COMPANY_USAGE_STATS,
  GET_MASTER_COMPANY_USAGE_STATS_SUCCESS,
  GET_MASTER_COMPANY_USAGE_STATS_FAILED,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID_SUCCESS,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID_FAILED,
  GET_COMPANY_LIST,
  GET_COMPANY_LIST_SUCCESS,
  GET_COMPANY_LIST_FAILED,
  GET_COMPANY_BY_ID,
  GET_COMPANY_BY_ID_SUCCESS,
  GET_COMPANY_BY_ID_FAILED,
  GET_COMPANY_RECENT_ACTIVITY_LIST,
  GET_COMPANY_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_COMPANY_RECENT_ACTIVITY_LIST_FAILED,
  MASTER_INVOICE_SEARCH,
  MASTER_INVOICE_SEARCH_SUCCESS,
  MASTER_INVOICE_SEARCH_FAILED,
  MASTER_INVOICE_PDF,
  MASTER_INVOICE_PDF_SUCCESS,
  MASTER_INVOICE_PDF_FAILED,
  MASTER_SYSTEM_ERROR_LOG_LIST,
  MASTER_SYSTEM_ERROR_LOG_LIST_SUCCESS,
  MASTER_SYSTEM_ERROR_LOG_LIST_FAILED,
  MASTER_SYSTEM_ERROR_LOG_DATA,
  MASTER_SYSTEM_ERROR_LOG_DATA_SUCCESS,
  MASTER_SYSTEM_ERROR_LOG_DATA_FAILED,
  MASTER_SYSTEM_ERROR_LOG_SEARCH,
  MASTER_SYSTEM_ERROR_LOG_SEARCH_SUCCESS,
  MASTER_SYSTEM_ERROR_LOG_SEARCH_FAILED,
  GET_MASTER_USER_LIST,
  GET_MASTER_USER_LIST_SUCCESS,
  GET_MASTER_USER_LIST_FAILED,
  GET_MASTER_RECENT_ACTIVITY_LIST,
  GET_MASTER_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_MASTER_RECENT_ACTIVITY_LIST_FAILED,
} from "./actionType";

//action
export const getMasterCompanyUsageStats = () => {
  return {
    type: GET_MASTER_COMPANY_USAGE_STATS,
  };
};
export const getMasterCompanyUsageStatsSuccess = (data) => {
  return {
    type: GET_MASTER_COMPANY_USAGE_STATS_SUCCESS,
    data,
  };
};
export const getMasterCompanyUsageStatsFailed = (error) => {
  return {
    type: GET_MASTER_COMPANY_USAGE_STATS_FAILED,
    error,
  };
};
export const getMasterCompanyUsageStatsById = (id) => {
  return {
    type: GET_MASTER_COMPANY_USAGE_STATS_BY_ID,
    id,
  };
};
export const getMasterCompanyUsageStatsByIdSuccess = (data) => {
  return {
    type: GET_MASTER_COMPANY_USAGE_STATS_BY_ID_SUCCESS,
    data,
  };
};
export const getMasterCompanyUsageStatsByIdFailed = (error) => {
  return {
    type: GET_MASTER_COMPANY_USAGE_STATS_BY_ID_FAILED,
    error,
  };
};
export const getCompanyList = () => {
  return {
    type: GET_COMPANY_LIST,
  };
};
export const getCompanyListSuccess = (data) => {
  return {
    type: GET_COMPANY_LIST_SUCCESS,
    data,
  };
};
export const getCompanyListFailed = (error) => {
  return {
    type: GET_COMPANY_LIST_FAILED,
    error,
  };
};
export const getCompanyById = (id) => {
  return {
    type: GET_COMPANY_BY_ID,
    id,
  };
};
export const getCompanyByIdSuccess = (data) => {
  return {
    type: GET_COMPANY_BY_ID_SUCCESS,
    data,
  };
};
export const getCompanyByIdFailed = (error) => {
  return {
    type: GET_COMPANY_BY_ID_FAILED,
    error,
  };
};

export const getCompanyRecentActivityList = (payload) => {
  return {
    type: GET_COMPANY_RECENT_ACTIVITY_LIST,
    payload,
  };
};
export const getCompanyRecentActivityListSuccess = (data) => {
  return {
    type: GET_COMPANY_RECENT_ACTIVITY_LIST_SUCCESS,
    data,
  };
};
export const getCompanyRecentActivityListFailed = (error) => {
  return {
    type: GET_COMPANY_RECENT_ACTIVITY_LIST_FAILED,
    error,
  };
};

export const masterInvoiceSearch = (payload) => {
  return {
    type: MASTER_INVOICE_SEARCH,
    payload,
  };
};
export const masterInvoiceSearchSuccess = (data) => {
  return {
    type: MASTER_INVOICE_SEARCH_SUCCESS,
    data,
  };
};
export const masterInvoiceSearchFailed = (error) => {
  return {
    type: MASTER_INVOICE_SEARCH_FAILED,
    error,
  };
};

export const masterInvoicePdf = (payload) => {
  return {
    type: MASTER_INVOICE_PDF,
    payload,
  };
};
export const masterInvoicePdfSuccess = (data) => {
  return {
    type: MASTER_INVOICE_PDF_SUCCESS,
    data,
  };
};
export const masterInvoicePdfFailed = (error) => {
  return {
    type: MASTER_INVOICE_PDF_FAILED,
    error,
  };
};

export const masterSystemErrorLogList = (payload) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_LIST,
    payload,
  };
};

export const masterSystemErrorLogListSuccess = (data) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_LIST_SUCCESS,
    data,
  };
};

export const masterSystemErrorLogListFailed = (error) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_LIST_FAILED,
    error,
  };
};

export const masterSystemErrorLogData = (payload) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_DATA,
    payload,
  };
};

export const masterSystemErrorLogDataSuccess = (data) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_DATA_SUCCESS,
    data,
  };
};

export const masterSystemErrorLogDataFailed = (error) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_DATA_FAILED,
    error,
  };
};

export const masterSystemErrorLogSearch = (payload) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_SEARCH,
    payload,
  };
};

export const masterSystemErrorLogSearchSuccess = (data) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_SEARCH_SUCCESS,
    data,
  };
};

export const masterSystemErrorLogSearchFailed = (error) => {
  return {
    type: MASTER_SYSTEM_ERROR_LOG_SEARCH_FAILED,
    error,
  };
};

export const getMasterUserList = () => {
  return {
    type: GET_MASTER_USER_LIST,
  };
};
export const getMasterUserListSuccess = (data) => {
  return {
    type: GET_MASTER_USER_LIST_SUCCESS,
    data,
  };
};
export const getMasterUserListFailed = (error) => {
  return {
    type: GET_MASTER_USER_LIST_FAILED,
    error,
  };
};

export const getMasterRecentActivityList = () => {
  return {
    type: GET_MASTER_RECENT_ACTIVITY_LIST,
  };
};
export const getMasterRecentActivityListSuccess = (data) => {
  return {
    type: GET_MASTER_RECENT_ACTIVITY_LIST_SUCCESS,
    data,
  };
};
export const getMasterRecentActivityListFailed = (error) => {
  return {
    type: GET_MASTER_RECENT_ACTIVITY_LIST_FAILED,
    error,
  };
};
